import uuid from 'uuid';
import {OrderIndex, OrderOptions} from '../models/Common';
import {MetricsActionType} from '../actions/metrics';
import {MetricsFilter} from '../models/Metric';

export interface TracksState {
    stateId: string,
    orderParams: OrderOptions,
    metricsFilter: MetricsFilter
}

const getInitialState = (): TracksState => {
    return {
        stateId: uuid.v4(),
        orderParams: {
            orderIndex: OrderIndex.ASC,
            orderBy: 'createdAt'
        },
        metricsFilter: {
            showIsFree: true,
            createdFromDays: 30000
        }
    };
};

export default function metrics(state = getInitialState(), action: any) {
    switch (action.type) {
        case MetricsActionType.UPDATE_ORDER_METRICS:
            return Object.assign({}, state, {
                orderParams: action.orderParams,
            });

        case MetricsActionType.UPDATE_METRICS_FILTER:
            return Object.assign({}, state, {
                metricsFilter: action.metricsFilter,
            });

        default: return state;
    }
}
